<script setup>
import { useMenuStore } from '@/store/menu';
import { computed, watch } from 'vue';

const menuStore = useMenuStore();

const groups = computed(() => menuStore.groups);

</script>
<template>
  <div class="menu-root">
    <div class="group-list">
      <div class="group-item" v-for="(group, index) in groups" :key="index">
        <div class="group-item-title">{{ group.label }}</div>
        <div class="group-item-content">
          <div
            class="group-item-content-item"
            v-for="(item, index) in group.children"
            :class="{ active: menuStore.activeComponent === item.name }"
            :key="index"
            v-text="item.title"
            @click="menuStore.setActiveComponent(item.name)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.menu-root {
  width: 100%;
  padding-top: 60px;
  .group-list {
    width: 100%;
    padding-left: 40px;
    padding-right: 20px;
    .group-item {
      width: 100%;
      .group-item-title {
        font-size: 18px;
        font-weight: bold;
      }
      .group-item-content {
        padding-top: 10px;
        margin-bottom: 20px;
        cursor: pointer;
        .group-item-content-item {
          font-size: 14px;
          width: 100%;
          height: 40px;
          padding: 0 12px;
          line-height: 40px;
          border-radius: 4px;
          & + .group-item-content-item {
            margin-top: 10px;
          }
          &:hover {
            background-color: var(--page-bg);
            color: var(--root-color);
          }
          &.active {
            background-color: var(--page-bg-active);
            color: var(--root-color);
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
